var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 18,
    viewBox: "0 0 66 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.1981L8.34651 3.4864C11.4464 0.232391 16.6178 0.16969 19.7957 3.34758L23.3238 6.87564C25.5593 9.11117 28.9017 9.82047 31.8524 8.68555L38.1459 6.26501C39.3635 5.7967 40.6771 5.63326 41.9724 5.78894L51.0558 6.8807C52.3331 7.03422 53.5545 7.49352 54.6165 8.21965L62.5278 13.629C63.4958 14.2908 64.2951 15.1704 64.8615 16.1971L65 16.4481",
    stroke: "url(#paint0_linear_52641_12432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52641_12432",
    x1: 72.5294,
    y1: -8.05245,
    x2: -5.09123,
    y2: -1.35255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9033A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251389,
    stopColor: "#EC3F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadLine);
export default __webpack_public_path__ + "static/media/bad-line.3dcbebb71b9a4664b9519855084ac0b5.svg";
export { ForwardRef as ReactComponent };